<template>
   <div
    ref="gjwbrandbox"
    class="gjw-brand-list gjw-flex-container gjw-flex-row gjw-transition-300"
    :class="isFolded ? 'gjw-folded' : ''"
  >
  <div ref="resultList" :class="platform==='web'?'filter-result-list':'filter-result-list-g'">
    <div class="result">相关结果 <span class="ft-theme">{{totalCount}}</span> 条</div>
    <div class="filter" v-if="filterCurveProperties.length">
      <div class="content" v-for="(curve,i) in filterCurveProperties" :key="i">
        <span class="label">{{ curve.label }}</span>
        <span class="value ft-theme">{{getCurveValue(curve)}}</span>
      </div>
      <i class="gjw-iconfont gjw-icon-close icon-close" @click="clearCurve" />
    </div>
    <div class="filter" v-for="(deviation) in filterDeviationProperties" :key="deviation.code">
      <span class="label">{{ deviation.name }}偏差</span>
      <span class="value ft-theme">± {{deviation.rate}}%</span>
      <i class="gjw-iconfont gjw-icon-close icon-close" @click="clearDeviationProperty(deviation)" />
    </div>
    <div class="filter" v-for="(product,index) in filterProductProperties" :key="index">
      <span class="label">{{ product.label }}</span>
      <span class="value ft-theme">{{ product.valueName }}</span>
      <i class="gjw-iconfont gjw-icon-close icon-close" @click="clearProductProperty(product)" />
    </div>
    <div ref="isshowReset" class="clear-filter ft-theme" v-if="filterCurveProperties.length || filterProductProperties.length" @click="clearFilters">
      清空
    </div>
    <div v-if="!isFolded" class="brand-selection-ad gjw-flex-container gjw-flex-row gjw-flex-horiz-right">
          <gjw-selection-attract :brand-code="null" :brand-name="null" :from="`more_brand`" />
    </div>
    <div
        class="clear-filter ft-theme"
        v-if="(resultHeight > 40)  && isFolded && positionReset "
        @click="clearFilters"
        style="position: absolute;right: 70px;">
        清空
    </div>
    <div
        v-if=" (resultHeight > 40) && positionReset"
        class="brand-list-btton gjw-flex-container gjw-flex-row gjw-flex-verti-center gjw-flex-horiz-center gjw-transition-300 "
        @click="onFoldBoxClick"
      >
        <span> {{ isFolded ? '更多' : '收起' }}</span>
        <i
          class="btn-arrow gjw-iconfont gjw-icon-arrow-down gjw-transition-300"
          :class="{'icon-rotate-180':!isFolded}"
        />
    </div>
  </div>

</div>
  
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'FilterResult',
  props: {
    curveSearchNames: {
      type: Array,
      default() {
        return ['风量', '全压']
      }
    },
    speedControl: {
      type: String,
      default: ''
    },
    curveProperties: {
      type: Array,
      default() {
        return []
      }
    },
    productProperties: {
      type: Array,
      default() {
        return []
      }
    },
    totalCount: {
      type: Number,
      default: null
    },
    gjwCategoryCode: {
      type: String,
      default: null
    }
  },
  watch: {
    curveProperties: {
      handler(newVal) {
        const filterCurveProps = []
        const filterDeviationProps = []
        const names = this.curveSearchNames
        for (let i = 0; i < names.length; i++) {
          let item = []
          if (this.gjwCategoryCode === 'C000001' || this.gjwCategoryCode === 'C000002') {
            item = newVal.filter((n) => n.label.indexOf(names[i]) !== -1)
          } else {
            item = newVal.filter((n) => n.label === names[i])
          }
          const values = []
          item.forEach((i) => {
            values.push(i.value)
            if (i.deviationRate || i.deviationRate === 0) {
              filterDeviationProps.push({
                name: i.label,
                rate: i.deviationRate,
                code: i.code,
                order: i.order
              })
            }
          })
          // filterCurveProps只会包括有搜索值的性能搜索属性
          if (values.length && values.some((v) => v || v === 0)) {
            const transferValues = values.map((v) => v || v === 0 ? v : '-')
            filterCurveProps.push({ label: names[i], values: transferValues })
          }
        }
        this.filterCurveProperties = filterCurveProps
        this.filterDeviationProperties = filterDeviationProps.sort((a, b) => { return a.order - b.order })
      },
      immediate: true
    },
    selectionParams: {
      handler(newVal) {
        this.isGDParams = true
        this.filterProductProperties = newVal
      },
      immediate: true
    },
    boxWidth: {
      handler(newVal) {
        this.resultNum = Math.floor((this.boxWidth - 150) / 160)
      },
      immediate: true
    },
    productProperties: {
      handler(newVal) {
        this.filterProductProperties = newVal
        if (this.platform === 'web') {
          this.positionReset = this.$refs.isshowReset?.offsetParent.offsetWidth - this.$refs.isshowReset?.offsetLeft
        } else {
          this.positionReset = this.$refs.isshowReset?.offsetParent.offsetWidth + 80 - this.$refs.isshowReset?.offsetLeft
        }
        setTimeout(() => {
          this.resultHeight = this.$refs.resultList?.getBoundingClientRect().height
        }, 300)
      },
      immediate: true
    },
    resultHeight: {
      handler(newVal) {
        this.resultHeight = this.$refs.resultList?.getBoundingClientRect().height
      },
      immediate: true
    },
  },
  computed: {
    ...mapGetters({
      isFromEntrance: 'isFromEntrance',
      platform: 'platform',
    }),
  },
  data() {
    return {
      // 形如[{ label: '风量', values: [1000, 900] }]
      filterCurveProperties: [],
      // 形如[{ name: '型号搜索', code: 'xxx',parentCode:'keyword'}]
      filterProductProperties: [],
      // 形如[{name:'高速风量',rate:'1',code:''}]
      filterDeviationProperties: [],
      isFolded: true,
      boxWidth: '',
      resultNum: '',
      positionReset: 0,
      initRight: 1100,
      resultHeight: '',
    }
  },
  created() {
    window.addEventListener('resize', this.getNum)
  },
  mounted() {
    window.addEventListener('resize', this.getNum)
    this.resultWidth = this.$refs.gjwbrandbox?.getBoundingClientRect().width
    this.resultHeight = this.$refs.resultList?.getBoundingClientRect().height
    this.positionReset = this.$refs.isshowReset?.getBoundingClientRect().right
    this.getNum()
  },
  methods: {
    getNum() {
      this.positionReset = this.$refs.isshowReset?.offsetParent.offsetWidth - this.$refs.isshowReset?.offsetLeft
      this.resultHeight = this.$refs.resultList?.getBoundingClientRect().height
    },
    getCurveValue(curve) {
      return curve.values.join('/')
    },
    clearCurve() {
      this.filterCurveProperties = []
      this.$emit('clear-curve-filter')
    },
    clearProductProperty(product) {
      this.filterProductProperties = this.filterProductProperties.filter((f) => f.valueCode !== product.valueCode)
      this.$emit('clear-product-filter', product)
    },
    clearDeviationProperty(deviation) {
      this.filterDeviationProperties = this.filterDeviationProperties.filter((d) => d.code !== deviation.code)
      this.$emit('clear-deviation-filter', deviation)
    },
    clearFilters() {
      this.$emit('clear-all-filters')
    },
    onFoldBoxClick() {
      this.isFolded = !this.isFolded   
    },
  }
}
</script>
<style lang='less' scoped>
.filter-result-list{
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding-right: 110px;
}
.filter-result-list-g{
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding-right: 110px;
}
.filter,.content,.clear-filter{
  display: flex; align-items: center;
}
.filter{
  margin: 6px 0;
  margin-right: 8px;
  padding: 0 6px 0 10px;
  border: 1px solid @theme-border-color;
  .value{
    padding: 0 12px 0 6px;
  }
}
.icon-close{
  font-size: 12px;
  cursor: pointer;
}
.clear-filter{
  margin: 6px 12px 6px 0;
  border: 1px solid @theme-color;
  padding: 0 6px;
  cursor: pointer;
  position: relative;
}
 .result{
    padding: 6px 6px 6px 0;
  }
  .gjw-brand-list {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #d2d7dc;
    border-top: none;

  &.gjw-folded {
    width: 100%;
    height: 36px;
    overflow: hidden;
    border-top: none;
  }
}
  .brand-list-btton {
      position: absolute;
      box-sizing: border-box;
      cursor: pointer;
      position: absolute;
      right: 8px;
      width: 64px;
      height: 24px;
      margin-top: 5px;
      text-align: center;
      border: 1px solid #d2d7dc;

      &:hover {
        color: #2dafcd;

        .btn-arrow {
          color: #2dafcd;
        }
      }

      .btn-arrow {
        color: #a9b0bd;

        &.icon-rotate-180 {
          transform: rotate(180deg);
          transition: all 0.3s;
        }
      }
    }
    .brand-selection-ad {
      margin-bottom: 18px;
    }
</style>
